
import { useLanguage } from "@/components/LanguageContext";

/**
 * Get a language-aware path - adds language prefix as needed
 */
export const getLanguagePath = (path: string, language: 'en' | 'pt' | 'es' | 'fr'): string => {
  // Don't add language prefix if path already has correct prefix
  if ((language === 'pt' && path.startsWith('/pt')) ||
      (language === 'es' && path.startsWith('/es')) ||
      (language === 'fr' && path.startsWith('/fr'))) {
    return path;
  }
  
  // For root path
  if (path === '/') {
    if (language === 'pt') return '/pt';
    if (language === 'es') return '/es';
    if (language === 'fr') return '/fr';
    return '/';
  }
  
  // Remove any existing language prefix
  let cleanPath = path;
  if (path.startsWith('/pt/') || path.startsWith('/es/') || path.startsWith('/fr/')) {
    cleanPath = path.substring(3);
  } else if (path === '/pt' || path === '/es' || path === '/fr') {
    cleanPath = '/';
  } else if (path.startsWith('/pt') || path.startsWith('/es') || path.startsWith('/fr')) {
    cleanPath = path.substring(3);
  }
  
  // Add appropriate prefix for non-English languages
  if (language === 'en') return cleanPath;
  return `/${language}${cleanPath === '/' ? '' : cleanPath}`;
};

/**
 * React hook to get language-aware paths
 */
export const useLanguagePath = () => {
  const { language } = useLanguage();
  
  return {
    getPath: (path: string) => getLanguagePath(path, language)
  };
};
